import React from 'react';

export const colors = [
  "#46d2ad", // teal
  "#70a0db", // blue
  "#ff9c66", // orange
  "#ae65e7", // purple
  "#5cd65c", // green
  "#f75572", // red
] as const;

export type Color = typeof colors[number]

export const patterns = ['bathroom-tiles', 'brick-wall', 'cerata', 'half-rombes', 'seigaiha'] as const

export type Pattern = typeof patterns[number]

export type CardPattern = { color: Color, pattern: Pattern };

export type PatternsMap = {
  [key in Pattern]: (color: Color) => React.CSSProperties;
}

export type UserType = {
  id: string;
  name: string;
};

export type RoomUserType = {
  id: string;
  name: string;
  observer: boolean;
  estimate?: string;
  pattern: CardPattern;
};

export type RoomType = {
  id: string;
  title: string;
  scale: string;
  users: { [key: string]: RoomUserType }
};
